import { render, staticRenderFns } from "./ProvinciasSelect.vue?vue&type=template&id=45e3fafb"
import script from "./ProvinciasSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./ProvinciasSelect.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports